export default __webpack_public_path__ + "static/media/OmDP.3157a6c0.jpg";